import React from 'react';
import TextEditor from '../../TextEditor/TextEditor';

export default function TemplateEditPage(props) {
	return (
		<div>
			<TextEditor {...props} />
		</div>
	);
}
